import { useDataMapDiagram } from 'map-editor/src';
import DataMapper from '../../common/DataMapper';
import { NodeMapDefinition, mapScenarios } from '@terragotech/gen5-datamapping-lib';
import { useSchemaLookup } from 'utils/useSchemaLookup';
import { useEffect, useMemo } from 'react';
import { getLocalSchemaDefinitions } from 'utils/Utils';
import { V2FormTemplate } from '@terragotech/form-renderer';
import { UseEventMapDiagramOutput } from 'map-editor/src/Hooks/useDataMapDiagram';

export const COMMAND_MULTI_EVENT_MAPPING_SCENARIO = 'COMMAND_MULTI_EVENT_MAPPING';
export const COMMAND_ZEBRA_MAPPING_SCENARIO = 'COMMAND_ZEBRA_MAPPING';

interface Props {
  mapping: NodeMapDefinition | undefined;
  commandId: string;
  aggregate: string;
  formDefinition: V2FormTemplate;
  mapperRef: { current: UseEventMapDiagramOutput | null };
  commandType?: string;
}

const CommandToEventMapper = ({
  mapping,
  commandId,
  aggregate,
  formDefinition,
  mapperRef,
  commandType
}: Props) => {
  const localSchemasWithDefinition = useMemo(() => getLocalSchemaDefinitions(formDefinition), [
    formDefinition,
  ]);
  const commandToEventMappingSchemaLookup = useSchemaLookup({
    localSchemas: localSchemasWithDefinition,
    commandId,
    currentAggregateType: aggregate,
  });


  const scenario = commandType === 'ZEBRA' ? COMMAND_ZEBRA_MAPPING_SCENARIO : COMMAND_MULTI_EVENT_MAPPING_SCENARIO;
  const commandToEventMappingDiagramOutput = useDataMapDiagram({
    dataMap: mapping || mapScenarios[scenario].defaultNodeMap,
    schemaLookup: commandToEventMappingSchemaLookup,
    scenario: scenario,
  });

  mapperRef.current = commandToEventMappingDiagramOutput;
  useEffect(() => {
    return () => {
      mapperRef.current = commandToEventMappingDiagramOutput;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DataMapper
      eventMapDiagramOutput={commandToEventMappingDiagramOutput}
      mapScenario={scenario}
    />
  );
};

export default CommandToEventMapper;
